import React, { useState } from 'react';
import { FaWhatsapp, FaTimes, FaPaperPlane } from 'react-icons/fa';
import './WhatsAppChat.css';

const WhatsAppChat = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');

  const phoneNumber = '917438037542'; // Replace with actual WhatsApp number
  const defaultMessage = 'Hi! I would like to know more about your services.';

  const toggleChat = () => {
    setIsOpen(!isOpen);
  };

  const sendMessage = () => {
    const textMessage = message || defaultMessage;
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(textMessage)}`;
    window.open(whatsappUrl, '_blank');
    setMessage('');
    setIsOpen(false);
  };

  const quickMessages = [
    'I need a website for my business',
    'What are your pricing plans?',
    'I want to discuss a project',
    'Can you help with e-commerce development?'
  ];

  return (
    <div className="whatsapp-chat">
      {isOpen && (
        <div className="chat-window">
          <div className="chat-header">
            <div className="chat-header-info">
              <div className="chat-avatar">
                <FaWhatsapp />
              </div>
              <div className="chat-details">
                <h4>Redfox Digital</h4>
                <span className="online-status">
                  <span className="status-dot"></span>
                  Online
                </span>
              </div>
            </div>
            <button className="close-chat" onClick={toggleChat}>
              <FaTimes />
            </button>
          </div>
          
          <div className="chat-body">
            <div className="chat-message bot-message">
              <div className="message-content">
                <p>👋 Hi there! Welcome to Redfox Digital!</p>
                <p>How can we help you today?</p>
              </div>
              <span className="message-time">Just now</span>
            </div>
            
            <div className="quick-messages">
              <p>Quick options:</p>
              {quickMessages.map((msg, index) => (
                <button
                  key={index}
                  className="quick-message-btn"
                  onClick={() => setMessage(msg)}
                >
                  {msg}
                </button>
              ))}
            </div>
          </div>
          
          <div className="chat-footer">
            <div className="message-input-container">
              <input
                type="text"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Type your message..."
                className="message-input"
                onKeyPress={(e) => e.key === 'Enter' && sendMessage()}
              />
              <button className="send-button" onClick={sendMessage}>
                <FaPaperPlane />
              </button>
            </div>
            <p className="chat-footer-text">
              We'll respond as soon as possible
            </p>
          </div>
        </div>
      )}
      
      <button className="whatsapp-float-btn" onClick={toggleChat}>
        {isOpen ? <FaTimes /> : <FaWhatsapp />}
        {!isOpen && <span className="notification-badge">1</span>}
      </button>
    </div>
  );
};

export default WhatsAppChat;